export default import.meta.ROLLDOWN_FILE_URL_KlIHHYOb9Pto3vj5s7i11A